import { useTranslation } from "react-i18next";
import AnimatedModal from "components/layout/motion/AnimatedModal";
import FunctionalButton from "components/layout/FunctionalButton";
import type { PayloadHealthIssueId } from "lib/mission/payloadHealthCheck";

interface PayloadHealthWarningDialogProps {
    visible: boolean;
    issues: PayloadHealthIssueId[];
    onContinue: () => void;
    onCancel: () => void;
}

const PayloadHealthWarningDialog: React.FC<PayloadHealthWarningDialogProps> = ({
    visible,
    issues,
    onContinue,
    onCancel,
}) => {
    const { t } = useTranslation(["missions", "common"]);

    const issueLabel = (id: PayloadHealthIssueId) => t(`dialogs.payloadHealthIssue.${id}`);

    return (
        <AnimatedModal
            visible={visible}
            onClose={onCancel}
            zIndexClassName="z-[200]"
            className="max-w-md rounded-r10 bg-black100 p-6"
        >
            <h2 className="mb-3 text-h4 font-semibold">{t("dialogs.payloadHealthTitle")}</h2>
            <p className="mb-4 text-h5 text-black40">{t("dialogs.payloadHealthBody")}</p>
            <ul className="mb-6 list-inside list-disc space-y-1 text-h5 text-black20">
                {issues.map((id) => (
                    <li key={id}>{issueLabel(id)}</li>
                ))}
            </ul>
            <div className="flex justify-end gap-2">
                <FunctionalButton
                    title={t("common:cancel")}
                    titleClassName="!normal-case"
                    className="text-h5 h-8 rounded-r5 border border-black70 bg-black90 px-3"
                    onClick={onCancel}
                />
                <FunctionalButton
                    title={t("dialogs.payloadHealthContinue")}
                    titleClassName="!normal-case"
                    className="text-h5 h-8 rounded-r5 border border-primary2 bg-primary2 px-3 hover:bg-primary1"
                    onClick={onContinue}
                />
            </div>
        </AnimatedModal>
    );
};

export default PayloadHealthWarningDialog;
